import React, { useState } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import BlogListingBanner from '../components/BlogListingBanner';
import BlogFilters from '../components/BlogFilters';
import BlogListing from '../components/BlogListing';
import NewsletterSignup from '../components/NewsletterSignup';

const BlogCategoryListingPageTemplate = ({
  data: {
    datoCmsBlogCategory,
    datoCmsBlog,
    allDatoCmsBlog: { nodes },
    allCategoryBlogPosts: { nodes: searchItems },
  },
  location,
  pageContext: { totalPageCount, currentPageCount },
}) => {
  const { seoMetaTags, title, featuredBlogPost } = datoCmsBlogCategory;

  const [searchResults, setSearchResults] = useState();

  return (
    <Layout seo={seoMetaTags} page={datoCmsBlogCategory}>
      <main>
        <BlogListingBanner
          heading={`${title} Blog Category`}
          item={featuredBlogPost ? featuredBlogPost : datoCmsBlog}
        />
        <BlogFilters
          currentPage={datoCmsBlogCategory}
          searchItems={searchItems}
          setSearchResults={setSearchResults}
          location={location}
        />
        <BlogListing
          heading={`Showing all ${title} posts`}
          items={nodes}
          searchResults={searchResults}
          totalPageCount={totalPageCount}
          listingPage={datoCmsBlogCategory}
          currentPageCount={currentPageCount}
        />
      </main>
      <NewsletterSignup />
    </Layout>
  );
};

export const BlogCategoryListingPageTemplateQuery = graphql`
  query BlogCategoryListingPageTemplateQuery(
    $id: String!
    $featuredBlogPostId: String
    $skip: Int!
  ) {
    datoCmsBlogCategory(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      slug
      featuredBlogPost {
        ...BlogCardFragment
      }
      ...LinkFragment
    }
    datoCmsBlog(id: { eq: $featuredBlogPostId }) {
      ...BlogCardFragment
    }
    allDatoCmsBlog(
      filter: {
        categories: { elemMatch: { id: { eq: $id } } }
        id: { ne: $featuredBlogPostId }
      }
      sort: { meta: { firstPublishedAt: DESC } }
      skip: $skip
      limit: 15
    ) {
      nodes {
        ...BlogCardFragment
      }
    }
    allCategoryBlogPosts: allDatoCmsBlog(
      filter: {
        categories: { elemMatch: { id: { eq: $id } } }
        id: { ne: $featuredBlogPostId }
      }
      sort: { meta: { firstPublishedAt: DESC } }
    ) {
      nodes {
        ...BlogCardFragment
      }
    }
  }
`;

export default BlogCategoryListingPageTemplate;
